import React, { useState } from 'react';

export default function Resume() {
  const [showAllExperience, setShowAllExperience] = useState(false);

  const experiences = [
    {
      company: 'Montefiore Health System',
      location: 'White Plains, New York',
      role: 'Team Lead',
      period: 'November 2022 - Present',
      logo: '/images/resume/montefiore.png',
      details: [
        'Lead a product team overseeing various healthcare software for revenue cycle operations, interfacing with the Epic EMR.',
        'Manage a suite of software including 3M 360 Encompass, 3M Core Grouping Software, PwC SMART, SmarterDx, and eCHARMS.',
      ],
    },
    {
      company: 'Montefiore Health System',
      location: 'Greater New York City Area',
      role: 'IT Systems Administrator',
      period: 'September 2018 - November 2022',
      logo: '/images/resume/montefiore.png',
      details: [
        'Engineered, implemented, and supported software solutions for opioid treatment programs (OTP).',
        'Focused on OTP EMR (SMART), primary care EMR (Epic), and revenue cycle systems.',
        'Managed interfaces between systems and performed Windows and Red Hat Enterprise Linux server maintenance.',
      ],
    },
    {
      company: 'Cohere Communications',
      location: 'Tarrytown, NY',
      role: 'Network Operations Center Engineer',
      period: 'October 2017 - September 2018',
      logo: '/images/resume/cohere.png',
      details: [
        'Provided data center maintenance at a Managed IT service provider.',
        'Managed Windows Servers, Hyper-V and VMware virtualization, Voice Over IP, and Windows/macOS workstations.',
      ],
    },
    {
      company: 'NTENT',
      location: 'New York',
      role: 'IT Support Technician',
      period: 'June 2015 - October 2017',
      logo: '/images/resume/ntent.png',
      details: [
        'Resolved challenging IT issues and delivered productivity solutions for a linguistic research firm.',
        'Administered Office 365, VoIP technologies, custom asset tracking systems, and workstations for global employees.',
      ],
    },
    {
      company: 'Self-Employed',
      location: 'Greater New York City Area',
      role: 'IT Consultant',
      period: '2008 - Present',
      iconBg: 'bg-gray-200 text-gray-600',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z" />
        </svg>
      ),
      details: [
        'Provide comprehensive technical consulting services to private clients, including hardware/software support, network setup, and system maintenance.',
      ],
    },
    {
      company: 'Acorda Therapeutics, Inc.',
      location: 'Ardsley, NY',
      role: 'Junior Network Administrator',
      period: 'June 2014 - August 2014 · 3 mos (Internship)',
      iconBg: 'bg-gray-200 text-gray-600',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 18.375V12m0-6.75V3.375M3 12h18M9.06 6.94l.012.002M14.94 6.94l-.012.002M9.06 17.06l.012-.002M14.94 17.06l-.012-.002" />
        </svg>
      ),
      details: [
        'Supported a five-member Network Operations team at a leading pharmaceutics firm.',
      ],
    },
    {
      company: 'Pace University',
      location: 'Pleasantville, NY',
      role: 'Information Technology Technician',
      period: 'September 2013 - May 2014 · 9 mos (Internship)',
      logo: '/images/resume/pace.png',
      details: [
        'Provided desktop support and resolved technology issues for university students and staff.',
      ],
    },
    {
      company: 'Westchester Community College',
      location: 'Valhalla, NY',
      role: 'Information Technology Tutor',
      period: 'September 2012 - July 2013 · 11 mos (Internship)',
      iconBg: 'bg-gray-200 text-gray-600',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.905 59.905 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5z" />
        </svg>
      ),
      details: [
        'Tutored students in Computer Information Systems (CIS) coursework to ensure concept mastery.',
      ],
    },
  ];

  const educations = [
    {
      institution: 'Pace University - Lubin School of Business',
      degree: 'Master of Business Administration (MBA), Management Information Systems',
      year: '2021',
      logo: '/images/resume/pace.png',
    },
    {
      institution: 'Pace University - Lubin School of Business',
      degree: 'Bachelor of Business Administration (BBA), Information Systems',
      year: '',
      logo: '/images/resume/pace.png',
    },
    {
      institution: 'White Plains Senior High School',
      degree: 'Advanced Regents Diploma',
      year: '',
      logo: '/images/resume/wpcsd.jpg',
    },
  ];

  const technicalSkills = [
    'System Administration & Engineering',
    'System Architecture',
    'Project Management',
    'Critical Thinking',
    'HTML5 & CSS3',
    'JavaScript (ES6+)',
    'React.js',
    'Git & GitHub',
  ];

  const languageSkills = [
    { name: 'English', level: 'Native or Bilingual' },
    { name: 'Urdu', level: 'Native or Bilingual' },
    { name: 'Hindi', level: 'Professional Working' },
    { name: 'Spanish', level: 'Professional Working' },
    { name: 'Arabic', level: 'Elementary' },
  ];

  const visibleExperiences = showAllExperience ? experiences : experiences.slice(0, 4);

  return (
    <main className="bg-gray-50 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900">Resume &amp; Professional Bio</h1>
          <p className="mt-4 text-lg text-gray-600">A summary of my skills, experience, and education.</p>
        </div>

        {/* About Me Section */}
        <section className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b border-gray-200 pb-3 mb-6">About Me</h2>
          <p className="text-gray-700 leading-relaxed">
            With a passion for producing effective business solutions, Sunny specializes in medical technology and server infrastructure. His expertise spans <strong>system engineering</strong> and <strong>system architecture</strong>, allowing him to design, implement, and support robust, scalable software solutions. As a team lead, he has honed strong <strong>managerial skills</strong>, guiding product teams to success in complex healthcare environments. In his free time, he researches emerging tech, tackles logical challenges, and dabbles in linguistics. Since 2008, he has also provided technical consulting services to private clients.
          </p>
        </section>

        {/* Skills Section */}
        <section className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b border-gray-200 pb-3 mb-6">Skills</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-3">Technical</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                {technicalSkills.map((skill, i) => (
                  <li key={i}>{skill}</li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-3">Languages</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                {languageSkills.map((lang, i) => (
                  <li key={i}>
                    <strong>{lang.name}:</strong> {lang.level}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        {/* Certifications Section */}
        <section className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b border-gray-200 pb-3 mb-6">Certifications</h2>
          <div className="flex items-start space-x-4">
            <img
              src="/images/resume/epic.png"
              alt="Epic Systems Logo"
              className="w-12 h-12 object-contain rounded-lg border border-gray-200 p-1 bg-white flex-shrink-0"
              onError={(e) => {
                e.target.src = 'https://logo.clearbit.com/epic.com';
              }}
            />
            <div>
              <p className="text-lg font-semibold text-gray-900">Health Information Management - Hospital Coding</p>
              <p className="text-gray-700">Epic Systems</p>
            </div>
          </div>
        </section>

        {/* Experience Section */}
        <section className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 mb-8">
          <div className="flex justify-between items-center border-b border-gray-200 pb-3 mb-6">
            <h2 className="text-2xl font-bold text-gray-900">Experience</h2>
            <button
              onClick={() => setShowAllExperience(!showAllExperience)}
              className="text-sm font-semibold text-indigo-600 hover:text-indigo-800 transition-colors"
            >
              {showAllExperience ? 'Show Less ↑' : 'Show More ↓'}
            </button>
          </div>

          <div className="space-y-8">
            {visibleExperiences.map((exp, i) => (
              <div key={i} className="flex items-start space-x-4">
                {exp.logo ? (
                  <img
                    src={exp.logo}
                    alt={`${exp.company} Logo`}
                    className="w-12 h-12 object-contain rounded-lg border border-gray-200 p-1 bg-white flex-shrink-0"
                  />
                ) : (
                  <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${exp.iconBg}`}>
                    {exp.icon}
                  </div>
                )}
                <div className="flex-1">
                  <p className="text-lg font-semibold text-gray-900">{exp.role}</p>
                  <p className="text-gray-700">{exp.company} | {exp.location}</p>
                  <p className="text-sm text-gray-500 mb-2">{exp.period}</p>
                  <ul className="list-disc list-inside text-gray-700 space-y-1">
                    {exp.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Education Section */}
        <section className="bg-white rounded-xl shadow-sm border border-gray-100 p-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b border-gray-200 pb-3 mb-6">Education</h2>
          <div className="space-y-6">
            {educations.map((edu, i) => (
              <div key={i} className="flex items-start space-x-4">
                <img
                  src={edu.logo}
                  alt={`${edu.institution} Logo`}
                  className="w-12 h-12 object-contain rounded-lg border border-gray-200 p-1 bg-white flex-shrink-0"
                />
                <div>
                  <p className="text-lg font-semibold text-gray-900">{edu.degree}</p>
                  <p className="text-gray-700">{edu.institution}</p>
                  {edu.year && <p className="text-sm text-gray-500">{edu.year}</p>}
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </main>
  );
}
